// ══════════════════════════════════════════════════════════════════════════════════════════════
//  EL REGISTRO DE LAS FUNCIONES EN DESARROLLO, EN LA PANTALLA (t279, 17-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El MISMO fichero que lee el servidor (shared/funciones.json, backend/services/funcionesRegistro.js). Aquí se usa para dos
//  cosas: saber si una clave EXISTE (una que no esté en el registro no enciende nada y lo dice en la consola; la guardia
//  services/funciones-interruptores.test.js la pone roja antes de subir) y saber de qué función es una dirección de la app
//  (`pantallas`), para las rutas y el menú. Lo encendido lo dice el servidor (utils/funcionesEstado).
import REGISTRO from '../../../shared/funciones.json' with { type: 'json' }
import { funcionEncendida, funcionesSabidas } from './funcionesEstado.js'

export const FUNCIONES = Object.freeze((REGISTRO && Array.isArray(REGISTRO.funciones) ? REGISTRO.funciones : []).map((f) => Object.freeze({ ...f })))
const POR_CLAVE = new Map(FUNCIONES.map((f) => [f.clave, f]))

export function existeFuncion(clave) {
  return POR_CLAVE.has(String(clave))
}

export function datosDeFuncion(clave) {
  return POR_CLAVE.get(String(clave)) || null
}

// ¿Encendida? Una clave que no está en el registro: apagada, y se dice (es un error de quien la ha escrito).
export function estaEncendida(clave) {
  if (!existeFuncion(clave)) {
    try { console.error('[funciones] «' + clave + '» no está en shared/funciones.json: añádela antes de usarla.') } catch (_) { /* sin consola */ }
    return false
  }
  return funcionEncendida(clave)
}

// La función de una dirección de la app («/coste-sillon» y lo que cuelga de ella), o null.
export function funcionDeRuta(ruta) {
  const p = String(ruta || '')
  for (const f of FUNCIONES) {
    for (const r of f.pantallas || []) if (p === r || p.startsWith(r + '/')) return f.clave
  }
  return null
}

// ¿Esta dirección es de una función apagada? (Sin saber todavía, sí: no se enseña.)
export function rutaApagada(ruta) {
  const c = funcionDeRuta(ruta)
  return !!c && !(funcionesSabidas() && funcionEncendida(c))
}
